import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ActivityService } from './features/http-services/activity.service';
import { Router } from '@angular/router';
import { SessionService } from './features/http-services/session.service';
import { ActiveTabService } from './features/http-services/active-tab.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'builder-xchange';

  @ViewChild("beforeExpired")
  beforeExpired!: TemplateRef<any>;
  
  @ViewChild("expired")
  expired!: TemplateRef<any>;
  @ViewChild("tokenExpired")
  tokenExpired!: TemplateRef<any>;

  seconds: number | undefined;

  constructor(
    private activityService: ActivityService,
    private sessionService: SessionService,
    private activeTabeService: ActiveTabService

  ) {
    activityService.secondsLeft.subscribe(
      (seconds) => (this.seconds = seconds)
    );
  }
  ngAfterViewInit(): void {
    this.activityService.passTemplate(this.beforeExpired, this.expired);
    this.sessionService.passTemplate(this.tokenExpired);
  }

  continueSession() {
    this.activityService.continueSession();
  }
  endSession() {
    this.activityService.endSession();
  }
  signIn() {
    this.activityService.releaseSessionLock();
    this.sessionService.logout();
  }
  tokenSignIn(){
    this.sessionService.redirectLoginPage();
  }
}
